import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>{this.props.pageTitle || "Desarrollo Web Full Stack Bootcamp | 100% online en vivo | DojoFullStack"}</title>
                    <meta name="description" content={this.props.pageTitle || "Desarrollo Web Full Stack Bootcamp | 100% online en vivo | DojoFullStack"} />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
